import React from 'react';
import { ConfigProvider } from 'antd';
import { brandTheme } from '@brand/theme';
import '@brand/tokens.css';

export const BrandProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <ConfigProvider theme={brandTheme}>
      {children}
    </ConfigProvider>
  );
};

